import { Injectable } from '@angular/core';
import { NavigationService } from '@core/navigation/navigation.service';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root',
})




export class AuthRoute {

    public static menu 

    constructor() {

    }

   

    requestValid(request :string):boolean{
        if(request.match(environment.apiURL)){
            if(!request.match(`${environment.apiURL}navigation/availablenav`)){
                return true
            }
        }
        return false
    }


    /**
     * Decodifica la URL del request
     * 
     */
    private decodeRequest(urlRequest:string){



    }

    getIdModulo(menu:any,path:string){

        let decode = path.substring(1).split('/')
        
        let path_user;
        if(!decode[1]){
            path_user='/'+decode[0]
        }else{
            path_user=decode[0]+'/'+decode[1]
        }
        let id_sub_modulo = null
        let encontrado= false;
        let default_menu= menu.default
       
        for (let i = 0; i < default_menu.length&&!encontrado; i++) {
            const modulo = default_menu[i];

            
            for (let j = 0; j < modulo.children.length&&!encontrado; j++) {
                const subModulo = modulo.children[j];


                
                if(subModulo.link.match(path_user)){
                    encontrado=true
                    id_sub_modulo=subModulo.id
                }

            
            }
        }
        return id_sub_modulo

    }

    static getPermisos(){
        console.log(AuthRoute.menu)
    }

}